import Vue from 'vue'
import Router from 'vue-router'
import Tab from '@/pages/tab'
import Index from '@/pages/index'
import Numbers from '@/pages/number'
import LinkLine from '@/pages/linkLine'
import Virtual from '@/pages/virtual'
import User from '@/pages/user'
import Mt_tab from '@/pages/mt_tab'
import Mt_index from '@/pages/mt_index'
import Mt_number from '@/pages/mt_number'
import Mt_linkLine from '@/pages/mt_linkLine'
import Mt_virtual from '@/pages/mt_virtual'
import Mt_user from '@/pages/mt_user'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '',
      name: 'tab',
      component: Tab,
      children: [
        {
          path: '',
          name: 'index',
          component: Index,
        },
        {
          path: '/number',
          name: 'number',
          component: Numbers,
        },
        {
          path: '/linkLine',
          name: 'linkLine',
          component: LinkLine,
        },
        {
          path: '/virtual',
          name: 'virtual',
          component: Virtual,
        },
        {
          path: '/user',
          name: 'user',
          component: User,
        }
      ]
    },
    {
      path: '/mt_tab',
      name: 'mt_tab',
      component: Mt_tab,
      children: [
        {
          path: '',
          name: 'mt_index',
          component: Mt_index,
        },
        {
          path: '/mt_number',
          name: 'mt_number',
          component: Mt_number,
        },
        {
          path: '/mt_linkLine',
          name: 'mt_linkLine',
          component: Mt_linkLine,
        },
        {
          path: '/mt_virtual',
          name: 'mt_virtual',
          component: Mt_virtual,
        },
        {
          path: '/mt_user',
          name: 'mt_user',
          component: Mt_user,
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js